export default "__VITE_ASSET__CI9JOv6c__"